import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "d-flex" };
const _hoisted_2 = {
    class: "me-4",
    style: { "min-width": "2rem" }
};
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("p", null, "Kunci Jawaban:", -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    const _component_text_area_form = _resolveComponent("text-area-form");
    const _component_el_table_column = _resolveComponent("el-table-column");
    const _component_richtext_form = _resolveComponent("richtext-form");
    const _component_radio_button_form = _resolveComponent("radio-button-form");
    const _component_el_radio = _resolveComponent("el-radio");
    const _component_el_table = _resolveComponent("el-table");
    return (_openBlock(), _createBlock(_component_el_table, {
        data: (_a = _ctx.competencyUnit.statements) === null || _a === void 0 ? void 0 : _a.filter((item) => item.answerTypeId === _ctx.answerTypeId),
        "scrollbar-always-on": true,
        "default-expand-all": ""
    }, {
        default: _withCtx(() => {
            var _a;
            return [
                _createVNode(_component_el_table_column, { type: "expand" }, {
                    default: _withCtx((scope) => {
                        var _a;
                        return [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(((_a = _ctx.competencyUnit.customAnswerFields) === null || _a === void 0 ? void 0 : _a.filter((item) => item.answerType.id === _ctx.answerTypeId)) || [], (item, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    (item.answerField.type === 'textarea')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (_ctx.isAssessment)
                                                ? (_openBlock(), _createBlock(_component_text_area_form, {
                                                    key: 0,
                                                    label: item.label,
                                                    modelValue: _ctx.modelStatementFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                        .statementFields].statementAnswerFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                        .statementAnswerFields].value,
                                                    "onUpdate:modelValue": ($event) => ((_ctx.modelStatementFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                        .statementFields].statementAnswerFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                        .statementAnswerFields].value) = $event),
                                                    disabled: _ctx.disabled,
                                                    autosize: { minRows: 3 },
                                                    rules: [_ctx.validationRequired()],
                                                    prop: `fields.${_ctx.order}.statementFields.${_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                        .statementFields}.statementAnswerFields.${_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                        .statementAnswerFields}.value`
                                                }, null, 8 /* PROPS */, ["label", "modelValue", "onUpdate:modelValue", "disabled", "rules", "prop"]))
                                                : (_openBlock(), _createBlock(_component_text_area_form, {
                                                    key: 1,
                                                    label: item.label,
                                                    disabled: _ctx.disabled,
                                                    autosize: { minRows: 3 }
                                                }, null, 8 /* PROPS */, ["label", "disabled"]))
                                        ], 64 /* STABLE_FRAGMENT */))
                                        : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */));
                            }), 128 /* KEYED_FRAGMENT */))
                        ];
                    }),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_el_table_column, {
                    label: "Pertanyaan",
                    width: "auto",
                    "min-width": "400"
                }, {
                    default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("span", _hoisted_2, _toDisplayString(`${scope.$index + 1}`), 1 /* TEXT */),
                            _createElementVNode("div", null, [
                                _createElementVNode("p", null, _toDisplayString(scope.row.description), 1 /* TEXT */),
                                (_ctx.isAllAdmin || _ctx.isAssessor)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_3,
                                        _createVNode(_component_richtext_form, {
                                            modelValue: scope.row.answerKey,
                                            "onUpdate:modelValue": ($event) => ((scope.row.answerKey) = $event),
                                            preview: ""
                                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                    ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(((_a = _ctx.competencyUnit.customAnswerFields) === null || _a === void 0 ? void 0 : _a.filter((item) => item.answerType.id === _ctx.answerTypeId)) || [], (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (item.answerField.type === 'radio')
                            ? (_openBlock(), _createBlock(_component_el_table_column, {
                                key: 0,
                                label: item.label,
                                align: "center"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option, optionIndex) => {
                                        return (_openBlock(), _createBlock(_component_el_table_column, {
                                            key: optionIndex,
                                            label: option.label,
                                            align: "center",
                                            width: "130"
                                        }, {
                                            default: _withCtx((scope) => [
                                                (_ctx.isAssessment)
                                                    ? (_openBlock(), _createBlock(_component_radio_button_form, {
                                                        key: 0,
                                                        modelValue: _ctx.modelStatementFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                            .statementFields].statementAnswerFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                            .statementAnswerFields].value,
                                                        "onUpdate:modelValue": ($event) => ((_ctx.modelStatementFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                            .statementFields].statementAnswerFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                            .statementAnswerFields].value) = $event),
                                                        options: [{ label: null, value: option.value }],
                                                        borderless: "",
                                                        disabled: _ctx.disabled,
                                                        center: "",
                                                        rules: [_ctx.validationRequired()],
                                                        prop: `fields.${_ctx.order}.statementFields.${_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                            .statementFields}.statementAnswerFields.${_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                            .statementAnswerFields}.value`
                                                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options", "disabled", "rules", "prop"]))
                                                    : (_openBlock(), _createBlock(_component_el_radio, {
                                                        key: 1,
                                                        label: option.value,
                                                        disabled: _ctx.disabled
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(null))
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "disabled"]))
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]))
                            : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */));
                }), 128 /* KEYED_FRAGMENT */))
            ];
        }),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["data"]));
}
